class LayerSubstations {

	constructor(context) {
		this.scenario	= context.tc.scenario;
		this.map		= context.tc.draw.map;
		this.du			= context.tc.draw;
		this.tc			= context.tc;
		this.context	= context;
	}

	json() {
		var points = this.scenario.substations.slice(0);
		LayerSubstations.data = {
			"type": "FeatureCollection",
			"features": []
		};

		LayerSubstations.data.features = points.map((f, idx) => {
			f.type = 'Feature';

			f.properties = {...f.properties};
			if (isNaN(f.id))
				f.properties.tempid = f.id;
			// else: f.id is already numeric — used as GeoJSON feature ID by MapLibre

			f.properties.idx	= idx;
			f.properties.id		= f.id;
			f.properties.name	= f.name ? f.name : 'Substation ' + f.id;
			return f;
		});

		const l = {
			'images': [
				{
					'src':	'/images/icons/substation_marker.png',
					'name':	'substationmarker'
				},
				{
					'src':	'/images/icons/substation_marker_hover.png',
					'name':	'substationmarker_hover'
				},
				{
					'src':	'/images/icons/substation_marker_on.png',
					'name':	'substationmarker_on'
				}
			],
			'source': {
				'id': LayerSubstations.sourceId,
				'type': 'geojson',
				'data': LayerSubstations.data
			},
			'layer': [
				{
					'id':		LayerSubstations.layerId,
					'type':		'symbol',
					'source':	LayerSubstations.sourceId,
					"paint": {
						'text-color':		"#000000",
						'text-halo-width':	1,
						'text-halo-color':	"#ffffff",
					},
					'layout': {
						'icon-image': ['case',
							['boolean', ['get', 'invisible'], false], '',
							['boolean', ['get', 'selected'],  false], 'substationmarker_on',
							['boolean', ['get', 'hover'],     false], 'substationmarker_hover',
							'substationmarker'
						],
						'icon-anchor':			'bottom',
						'icon-allow-overlap':	true,
						'text-field': ['case',
							['boolean', ['get', 'invisible'], false], '',
							['get', 'name']
						],
						'text-rotation-alignment':	"auto",
						'text-allow-overlap':		true,
						'text-anchor':				"top",
						'text-size':				14,
					},
				}
			]
		};
		return l;
	}
}

LayerSubstations.layerId	= 'substations_layer';
LayerSubstations.sourceId	= 'substations_source';

export default LayerSubstations;
